<template>
  <div id="app">
    <v-main>
      <component :is="layout">
        <router-view />
      </component>
    </v-main>
  </div>
</template>

<script>
export default {
  name: "app",
  components: {},
  data() {
    return {};
  },
  computed: {
    layout() {
      return this.$route.meta.layout + "-layout";
    },
  },
};
</script>
